import * as actionTypes from "./actionTypes"
import * as types from "./types"



const initState: types.IDataProvisioningWorkflowState = {
    isActive: false,
    step: 0,
    previousStep: 0,
    selectedDataSet: null,
    selectedDataTarget: null,
    dataLoaderFormState: {},
    initialOptions: true
};

export const DataProvisioningWorkflowReducer = (state = initState, action: types.DataProvisioningWorkflowActions) => {
    switch (action.type) {
        case actionTypes.ENABLE_WORKFLOW:
            return {
                ...state,
                isActive: true,
            };
            case actionTypes.DISABLE_WORKFLOW:
                return {
                    ...state,
                    isActive: false,
                };
            case actionTypes.RESET_WORKFLOW:
                return {
                    ...initState
                };
            case actionTypes.TRIGGER_MAIN_WORKFLOW:
                return {
                    ...state,
                    initialOptions: false,
                };
    
    
            // Workflow steps
            case actionTypes.NEXT_STEP:
                return {
                    ...state,
                    step: state.step + 1,
                    previousStep: state.step
                };
            case actionTypes.PREV_STEP:
                return {
                    ...state,
                    step: state.step - 1,
                    previousStep: state.step
                };
            case actionTypes.GOTO_STEP:
                return {
                    ...state,
                    step: action.step,
                    previousStep: state.step
                };
            
            // Toggle data
            case actionTypes.TOGGLE_SELECTED_DATA_SET:
                return {
                    ...state,
                    selectedDataSet: action.dataSet === state.selectedDataSet ? null : action.dataSet
                };
            case actionTypes.TOGGLE_SELECTED_DATA_TARGET:
                return {
                    ...state,
                    selectedDataTarget: action.dataTarget === state.selectedDataTarget ? null :action.dataTarget
                };
            case actionTypes.SAVE_DATA_LOADER_FROM_STATE:
                return {
                    ...state,
                    dataLoaderFormState: action.state
                };
        default:
            return {
                ...state,
            };
    }
};

/*const initialDataProvisioningWorkflowState: types.IDataProvisioningWorkflowState = {
    isActive: false,
    step: 0,
    previousStep: 0,
    selectedDataSet: null,
    selectedDataTarget: null,
    dataLoaderFormState: {},
};

export const DataProvisioningWorkflowReducer = (state = initialDataProvisioningWorkflowState, action: types.DataProvisioningWorkflowActions) => {
    switch (action.type) {

        // Toggle Workflow
        case actionTypes.ENABLE_WORKFLOW:
            return {
                ...state,
                isActive: true,
            };
        case actionTypes.DISABLE_WORKFLOW:
            return {
                ...state,
                isActive: false,
            };
        case actionTypes.RESET_WORKFLOW:
            return {
                initialDataProvisioningWorkflowState
            };

        // Workflow steps
        case actionTypes.NEXT_STEP:
            return {
                ...state,
                step: state.step + 1,
                previousStep: state.step
            };
        case actionTypes.PREV_STEP:
            return {
                ...state,
                step: state.step - 1,
                previousStep: state.step
            };
        case actionTypes.GOTO_STEP:
            return {
                ...state,
                step: action.step,
                previousStep: state.step
            };
        
        // Toggle data
        case actionTypes.TOGGLE_SELECTED_DATA_SET:
            return {
                ...state,
                selectedDataSets: action.dataSet === state.selectedDataSet ? null : action.dataSet
            };
        case actionTypes.TOGGLE_SELECTED_DATA_TARGET:
            return {
                ...state,
                selectedDataTargets: action.dataTarget === state.selectedDataTarget ? null :action.dataTarget
            };
        case actionTypes.SAVE_DATA_LOADER_FROM_STATE:
            return {
                ...state,
                dataLoaderFormState: action.state
            };
        default:
            return {
                ...state,
            };
    }
};*/